var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step bg-white" },
    [
      _c(
        "div",
        { staticClass: "form" },
        [
          _c(
            "yxt-form",
            {
              ref: "refForm",
              attrs: {
                "label-position": "top",
                "label-width": "80px",
                model: _vm.formData,
                "is-need-require": "",
                "is-need-tooltip": "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "step-subtitle" },
                [
                  _c("span", { staticClass: "text color-gray-10" }, [
                    _vm._v(_vm._s(_vm.$t("pc_subtitle_audit_none"))),
                  ]),
                  _c(
                    "yxt-tooltip",
                    [
                      _c("yxt-svg", {
                        staticClass: "color-gray-6 hover-primary-6",
                        attrs: {
                          "remote-url": "",
                          width: "16px",
                          height: "16px",
                          "icon-class": "question-cirlce-o",
                        },
                      }),
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("pc_tip_audit_none_case"))
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              1." +
                                _vm._s(_vm.$t("pc_tip_audit_none_case_1")) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              2." +
                                _vm._s(_vm.$t("pc_tip_audit_none_case_2")) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              3." +
                                _vm._s(_vm.$t("pc_tip_audit_none_case_3")) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              4." +
                                _vm._s(_vm.$t("pc_tip_audit_none_case_4")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                { staticClass: "mb-14" },
                [
                  _c(
                    "yxt-radio-group",
                    {
                      model: {
                        value: _vm.formData.noAuditer,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "noAuditer", $$v)
                        },
                        expression: "formData.noAuditer",
                      },
                    },
                    [
                      _c("yxt-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("pc_care_of_audit"))),
                      ]),
                      _c("yxt-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("pc_care_of_sb"))),
                      ]),
                      _c("yxt-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("pc_auto_pass"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.noAuditer === 1
                ? _c(
                    "yxt-form-item",
                    {
                      staticClass: "bg-gray-1 admins-select",
                      attrs: { prop: "user" },
                    },
                    [
                      _c("yxt-select", {
                        attrs: {
                          value: _vm.getUser,
                          multiple: "",
                          "icon-name": "more",
                          "hidden-option": "",
                          "value-key": "id",
                          "prop-label": "fullname",
                          placeholder: _vm.$t("pc_select_placeholder"),
                        },
                        on: { "visible-change": _vm.handleShowSelector },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "tag",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: data.currentLabel },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1309020200
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "step-subtitle" },
                [
                  _c("span", { staticClass: "text color-gray-10" }, [
                    _vm._v(_vm._s(_vm.$t("pc_title_audit_remind"))),
                  ]),
                  _c(
                    "yxt-tooltip",
                    [
                      _c("yxt-svg", {
                        staticClass: "color-gray-6 hover-primary-6",
                        attrs: {
                          "remote-url": "",
                          width: "16px",
                          height: "16px",
                          "icon-class": "question-cirlce-o",
                        },
                      }),
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              1. " +
                                _vm._s(_vm.$t("pc_title_remind_tip"))
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              2. " +
                                _vm._s(_vm.$t("pc_title_remind_tip_2")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                { staticClass: "real-rmdr" },
                [
                  _c(
                    "yxt-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      model: {
                        value: _vm.formData.realRmdr,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "realRmdr", $$v)
                        },
                        expression: "formData.realRmdr",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("pc_real_rmdr")))]
                  ),
                  _c(
                    "yxt-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      model: {
                        value: _vm.formData.rmdrStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "rmdrStatus", $$v)
                        },
                        expression: "formData.rmdrStatus",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("pc_real_rmdr1")))]
                  ),
                ],
                1
              ),
              _vm.formData.rmdrStatus === 1
                ? _c(
                    "yxt-form-item",
                    {
                      staticClass: "bg-gray-1 real-rmdr-input",
                      attrs: { prop: "rmdrTime" },
                    },
                    [
                      _c("span", { staticClass: "color-gray-8" }, [
                        _vm._v(_vm._s(_vm.$t("pc_txt_everday"))),
                      ]),
                      _c("yxt-input-number", {
                        attrs: {
                          min: 6,
                          max: 23,
                          step: 1,
                          "step-strictly": "",
                        },
                        on: {
                          blur: function ($event) {
                            !_vm.formData.rmdrTime &&
                              (_vm.formData.rmdrTime = 10)
                          },
                        },
                        model: {
                          value: _vm.formData.rmdrTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "rmdrTime", $$v)
                          },
                          expression: "formData.rmdrTime",
                        },
                      }),
                      _c("span", { staticClass: "color-gray-8" }, [
                        _vm._v(_vm._s(_vm.$t("pc_rmdr_times"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "step-subtitle suggest-title" },
                [
                  _c("yxt-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.formData.suggest,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "suggest", $$v)
                      },
                      expression: "formData.suggest",
                    },
                  }),
                  _c("span", { staticClass: "text color-gray-10" }, [
                    _vm._v(_vm._s(_vm.$t("pc_audit_suggest"))),
                  ]),
                ],
                1
              ),
              _vm.formData.suggest === 1
                ? _c(
                    "yxt-form-item",
                    { staticClass: "suggest-item bg-gray-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "suggest-radio" },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.$t("pc_ok_when")))]),
                          _c(
                            "yxt-radio-group",
                            {
                              model: {
                                value: _vm.formData.agree,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "agree", $$v)
                                },
                                expression: "formData.agree",
                              },
                            },
                            [
                              _c("yxt-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("pc_txt_optional"))),
                              ]),
                              _c("yxt-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("pc_txt_required"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "suggest-radio" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("pc_reject_when"))),
                          ]),
                          _c(
                            "yxt-radio-group",
                            {
                              model: {
                                value: _vm.formData.reject,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "reject", $$v)
                                },
                                expression: "formData.reject",
                              },
                            },
                            [
                              _c("yxt-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("pc_txt_optional"))),
                              ]),
                              _c("yxt-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("pc_txt_required"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "subtitle" }, [
                _c("span", { staticClass: "text color-gray-10" }, [
                  _vm._v("其它"),
                ]),
              ]),
              _c(
                "yxt-form-item",
                { attrs: { prop: "autoPassAuditSelf" } },
                [
                  _c(
                    "yxt-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      model: {
                        value: _vm.formData.autoPassAuditSelf,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "autoPassAuditSelf", $$v)
                        },
                        expression: "formData.autoPassAuditSelf",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm
                            .$t("pc_audit_tips_auth")
                            .d("审核人和发起人是同一个人，审核自动通过")
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            "header-border": false,
            "destroy-on-close": true,
            size: "960px",
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("yxt-single-user", {
            attrs: {
              "function-code": _vm.functionCode,
              "data-permission-code": _vm.dataPermissionCode,
            },
            model: {
              value: _vm.user,
              callback: function ($$v) {
                _vm.user = $$v
              },
              expression: "user",
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_cancel")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRolesOk },
                },
                [_vm._v(_vm._s(_vm.$t("pc_ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }